import { render, staticRenderFns } from "./MasterListSideNav.vue?vue&type=template&id=0504a38c&scoped=true&"
import script from "./MasterListSideNav.vue?vue&type=script&lang=js&"
export * from "./MasterListSideNav.vue?vue&type=script&lang=js&"
import style0 from "./MasterListSideNav.vue?vue&type=style&index=0&id=0504a38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0504a38c",
  null
  
)

export default component.exports